import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { LogoutUserProps } from './LogoutUser.types';

export const LogoutUser = ({ onSubmit, onModalClose, onModalOpen, isModalOpen, isLoading }: LogoutUserProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <ActionButton type="logout" onClick={onModalOpen} />

      <ActionModal
        header={formatMessage({ id: AppMessages['user.logout.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        submitButtonDisabled={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['user.logout.submitButton'] })}
      >
        <ActionModal.Text>{formatMessage({ id: AppMessages['user.logout.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
